import { MapContainer, Polygon, TileLayer, Tooltip } from "react-leaflet";
import { LatLngExpression } from "leaflet";
import "./index.scss";
import Container from "../CustomView/Container";
import Row from "../CustomView/Row";
import { Col } from "react-bootstrap";
import ReactDOMServer from "react-dom/server";
import { ICreateAndUpdateArea, ILatLng } from "../../types/area.interface";
import DescriptionArea from "../../screen/AreaScreen/Components/Body/DescriptionArea";
import React, { useEffect } from "react";

const CustomLeafLetArea = ({
  items,
  onEdit,
  onRemove,
  onClickEvent,
  defaultLatLngArea = { lat: 36.92448, lng: 50.641372 },
}: {
  items?: ICreateAndUpdateArea[];
  onEdit?: (area: ICreateAndUpdateArea) => void;
  onRemove?: (area: ICreateAndUpdateArea) => void;
  onClickEvent?: (area: ICreateAndUpdateArea) => void;
  defaultLatLngArea?: ILatLng;
}): JSX.Element => {
  const center: LatLngExpression = [
    defaultLatLngArea?.lat as number,
    defaultLatLngArea?.lng as number,
  ];

  const mapRef: any = React.createRef();

  const purpleOptions = { color: "purple" };

  useEffect(() => {
    if (mapRef.current) {
      // mapRef.current.setView([defaultLatLngArea?.lat, defaultLatLngArea?.lng]);
      mapRef.current.setView(
        [defaultLatLngArea?.lat, defaultLatLngArea?.lng],
        11
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [defaultLatLngArea?.lat, defaultLatLngArea?.lng]);
  return (
    <Container>
      <Row className="map-modal-container">
        <Col id="map-holder-area">
          <MapContainer center={center} zoom={11} ref={mapRef}>
            <TileLayer
              attribution='© <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
              url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            />
            {items?.map(
              (item) =>
                item?.coords && (
                  <Polygon
                    pathOptions={purpleOptions}
                    positions={item?.coords as LatLngExpression[][]}
                    eventHandlers={{
                      click: (e) => {
                        onClickEvent!(item);
                      },
                    }}

                    // eventHandlers={{
                    //   mouseover: (e) => {
                    //     e.target.bindPopup(areaDescription(item)).openPopup();
                    //   },
                    //   mouseout: (e) => {
                    //     e.target.closePopup();
                    //   },
                    // }}
                  >
                    <Tooltip>{item?.title}</Tooltip>
                  </Polygon>
                )
            )}
            {/* {items && (
              <Polygon
                pathOptions={purpleOptions}
                positions={items.coords as LatLngExpression[][]}
              >
                <Tooltip sticky>fvfvfv</Tooltip>
              </Polygon>
            )} */}
            {/* <Rectangle bounds={bounds} pathOptions={blackOptions} /> */}
          </MapContainer>
        </Col>
      </Row>
    </Container>
  );
};

export default CustomLeafLetArea;
